$(document).ready(function () {
   'use strict';

   $(document).on( 'click', '#newsletter-option-toggle', function () {
      $('#newsletter-option-wrapper').slideToggle();
      $('#triangle').toggleClass('triangle-rotate');
   });

   if ($('#TechSmithNews_CurrentState').is(':checked')) {
      $('#newsletter-option-toggle').show();
   }

   $(document).on( 'change', '#TechSmithNews_CurrentState', function () {
      if ($('#TechSmithNews_CurrentState').is(':checked')) {
         $('#newsletter-option-wrapper').slideDown();
         $('#triangle').addClass('triangle-rotate');
         $('#newsletter-option-toggle').slideDown();
      }
      else {
         $('#newsletter-option-wrapper').slideUp();
         $('#triangle').removeClass('triangle-rotate');
         $('#newsletter-option-toggle').slideUp();
      }
   });

   var initialCheckedOptions = $('#email-preferences-form input:checkbox:checked');
   $(document).on( 'change', '#email-preferences-form input:checkbox', function () {
      var checked = $('#email-preferences-form input:checkbox:checked');
      if (checked.length !== initialCheckedOptions.length) {
         $('#newsletter-submit-button').prop('disabled', false);
         return;
      }
      for (var i = 0; i < checked.length; i++) {
         if (checked[i] !== initialCheckedOptions[i]) {
            $('#newsletter-submit-button').prop('disabled', false);
            return;
         }
      }
      $('#newsletter-submit-button').prop('disabled', true);
   });

   $(document).on( 'click', '#unsubscribe-from-all-button,.unsubscribe-from-all-button', function (e) {
      e.preventDefault();
      var form = $('#unsubscribe-from-all-button').closest('form');
      form.submit();
   });

   var oldEmailAddress = window.oldEmailAddress;

   function showChangeEmailForm() {
      $('#change-email-form-content-wrapper').fadeTo(0, 1);
      $('#change-email-address-form-wrapper').slideDown();
      $('#change-email-address-button-wrapper').hide();
      $('#displayed-email-address').hide();
      $('#NewEmailAddress').select();
   }

   function hideChangeEmailForm() {
      $('#change-email-form-content-wrapper').fadeTo(0, 0);
      $('#change-email-address-form-wrapper').slideUp();
      $('#displayed-email-address').show();
      $('#change-email-address-button-wrapper').show();
      $('#change-email-wave-spinner').hide();
      $('#change-email-change-button').attr('disabled', true);
      var handler = new ErrorMessageHandler();
      handler.clear();
   }

   $('#change-email-address-button').click(showChangeEmailForm);

   $('#change-email-cancel-button').click(function () {
      hideChangeEmailForm();
      $('#NewEmailAddress').val(oldEmailAddress);
   });

   $('#change-email-address-form').submit(function (e) {
      e.preventDefault();
      if (!$(this).valid()) {
         $('#change-email-change-button').attr('disabled', true);
         return;
      }
      var newEmail = $('#NewEmailAddress').val();
      if (newEmail === oldEmailAddress) {
         return;
      }
      $.ajax({
         url: '/api/v/1/emailpreferences/changeemailaddress',
         method: 'PUT',
         dataType: 'json',
         data: {
            NewEmailAddress: newEmail,
            OldEmailAddress: oldEmailAddress
         },
         beforeSend: function () {
            $('#change-email-wave-spinner').show();
         },
         success: function (data) {
            hideChangeEmailForm();
            updateEmailAddress(newEmail);
         },
         error: function (x, t) {
            var handler = new ErrorMessageHandler();
            if (t === 'timeout') {
               handler.showError('Request timed out, please try again.');
               return;
            }
            var response = JSON.parse(x.responseText);
            if (response.Response === 'Error') {
               handleApiError(response);
            }
	    else {
              handler.showError('An unknown error has occurred.');
	    }
            $('#change-email-wave-spinner').hide();
         }
      });

      function updateEmailAddress(email) {
         oldEmailAddress = email;

         // Remove the query string from the url if there is one.
         window.history.replaceState({}, document.title, window.location.origin + window.location.pathname);

         $('#displayed-email-address').html(email);

         // Change the values for each form submit to the new email address
         $('input[name=Email]').val(email);
         $('#NewEmailAddress').val(email);

         var handler = new ErrorMessageHandler();
         handler.clear();

         hideChangeEmailForm();
      }

      function handleApiError(data) {
         var handler = new ErrorMessageHandler();
         handler.showError(data.Message);
      }
   });

   $('#NewEmailAddress').on('input', function () {
      var newEmail = $('#NewEmailAddress').val();
      var errorMessageVisible = $('#NewEmailAddress-error').is(':visible');
      if (oldEmailAddress === newEmail || errorMessageVisible || !newEmail) {
         $('#change-email-change-button').attr('disabled', true);
      } else {
         $('#change-email-change-button').attr('disabled', false);
      }
   });

   function ErrorMessageHandler() {
      var element = $('#change-email-error-message');

      this.showError = function (errorMessage) {
         element.empty();
         element.html(errorMessage);
         element.show();
      };

      this.appendError = function (errorMessage) {
         element.append(errorMessage);
         element.append('<br />');
      };

      this.clear = function () {
         element.hide();
         element.empty();
      };

      this.clear();
   }
});
